export const carouselProgressiveCircles = {
    data() {
        return {
            activeSlide: 0
        }
    },
    methods: {
        setActive(index) {
            this.$refs.flickity.select(index);
        },
        selectActiveSlide(flkty) {
            this.activeSlide = flkty.selectedIndex;
        }
    },
}
